import { InitiativeSubmissionState, initiativeSubmissionInitialState } from './State'

import {
  SET_INITIATIVE_DATA,
  SET_IS_LOADING_INITIATIVE_DATA,
  SET_GPA_GRADE,
  SET_IS_SAVING_INITIATIVE_DATA,
  SET_QUESTION_ANSWER,
  InitiativeSubmissionAction,
  SET_GPA_VALUE,
  SET_CURRENT_DATE_TIME,
  SET_LAST_AUTO_SAVE_DATE,
  SET_VALIDATION_ERROR,
  SET_ANSWERS_STATE,
  SET_IS_SUBMITTING,
  SET_IS_SUCCESS_DIALOG_OPEN,
  SET_IS_INCOMPLETE_PROFILE_DIALOG_OPEN,
  COMPLETE_INITIATIVE_LOADING,
  SET_VALIDATION_STATE,
  RESET
} from './Actions'

function initiativeSubmissionReducer(
  state: InitiativeSubmissionState,
  action: InitiativeSubmissionAction
): InitiativeSubmissionState {
  switch (action.type) {
    case SET_INITIATIVE_DATA:
      return Object.assign({}, state, { initiativeData: action.payload })
    case SET_IS_LOADING_INITIATIVE_DATA:
      return Object.assign({}, state, { isLoadingInitiative: action.payload })
    case SET_IS_SAVING_INITIATIVE_DATA:
      return Object.assign({}, state, { isSavingInitiativeData: action.payload })
    case SET_GPA_VALUE:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          gpa: action.payload
        }
      })
    case SET_GPA_GRADE:
      return {
        ...state,
        answers: {
          ...state.answers,
          gpaGrade: action.payload
        }
      }
    case SET_QUESTION_ANSWER:
      const questions = Object.assign({}, state.answers.questions, action.payload)
      const answers = Object.assign({}, state.answers, { questions })
      return Object.assign({}, state, { answers })
    case SET_CURRENT_DATE_TIME:
      return Object.assign({}, state, { currentDateTime: action.payload })
    case SET_LAST_AUTO_SAVE_DATE:
      return Object.assign({}, state, { lastAutoSaveDate: action.payload })
    case SET_ANSWERS_STATE:
      return Object.assign({}, state, { answers: action.payload })
    case SET_VALIDATION_ERROR:
      return Object.assign({}, state, { validationError: action.payload })
    case SET_IS_SUBMITTING:
      return Object.assign({}, state, { isSubmitting: action.payload })
    case SET_IS_SUCCESS_DIALOG_OPEN:
      return Object.assign({}, state, { isSuccessDialogOpen: action.payload })
    case SET_IS_INCOMPLETE_PROFILE_DIALOG_OPEN:
      return Object.assign({}, state, { isIncompleteProfileDialogOpen: action.payload })
    case COMPLETE_INITIATIVE_LOADING:
      return Object.assign({}, state, action.payload)
    case SET_VALIDATION_STATE:
      return Object.assign({}, state, { validationState: action.payload })
    case RESET:
      return initiativeSubmissionInitialState
    default:
      return state
  }
}

export default initiativeSubmissionReducer
